import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/heroCarousel/heroCarousel.js';
import { joinClasses, accessNested } from 'utils/utils';
import { navigateInternally } from 'utils/bolt/index';
import { trackHeroEngagement } from 'utils/track';
import Transition from 'components/core/transition/transition';
import Store from 'store/store';

import s from 'components/bolt/hub/components/heroCarousel/heroCarousel.sss';

export default class HeroCarousel extends BaseComp.default {

	trackHeroClick(title, label) {
		trackHeroEngagement('hero-button-click', label);
	}

	onSlideClick({ target }, index, slidePath, slideTitle, textOverlay, textOverlayId, videoOverlay) {
		if (
			this.state.hasTextOverlayOpen ||
			(target?.className?.includes && target.className.includes('hubTextOverlay'))
		) return;

		const tile = this.slideRefs[`slide${index}`];

		if (tile.contains(target) && (this.buttons && !this.buttons.contains(target))) {
			trackHeroEngagement('hero-click', slideTitle);
			if (textOverlay && textOverlayId) {
				this.toggleTextOverlay(true, textOverlayId);
				return;
			}
			if (videoOverlay) {
				return Store.emit('ENABLE_TRAILER_OVERLAY', videoOverlay?.video);
			}
			if (slidePath) {
				if (slidePath.startsWith('http') || slidePath.startsWith('mailto:')) {
					let link = document.createElement('a');
					link.href = slidePath;
					link.target = '_blank';
					link.style.display = 'none';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} else {
					navigateInternally(slidePath);
				}
			}
		}
	}

	renderBackgrounds() {
		const isDesktopSize = accessNested(this.props, 'client.isDesktopSize', false);
		const resolution = isDesktopSize ? 'desktop' : 'mobile';

		const { activeIndex } = this.state;
		const slide = this.slides[activeIndex];
		const img = slide.background?.[resolution] || slide.background?.desktop || slide.background?.mobile || '';
		const backgroundAlignment = slide.background?.backgroundAlignment || 'center';
		const hasGradient = accessNested(this.props, 'appData.heroCarousel.hasGradient', false);

		const textOverlay = slide?.textOverlay?.content;
		const textOverlayId = `slide${activeIndex}`;
		const videoOverlay = slide?.videoOverlay;

		return (
			<Transition duration={800}>
				<div
					class={joinClasses(s.slide, s[slide.id], slide.dark && s.dark, s[backgroundAlignment])}
					id={`slide${activeIndex}`}
					onClick={e => this.onSlideClick(e, activeIndex, slide.path, slide.title, textOverlay, textOverlayId, videoOverlay)}
					ref={ref => this.slideRefs[`slide${activeIndex}`] = ref}
				>
					{!!img && <img src={img} alt={slide.background.alt} />}
					{hasGradient && <div class={s.gradient} />}
					{this.renderContent(slide)}
					{slide.buttons && this.renderButtons(slide.buttons, slide, activeIndex)}
					{textOverlay && this.renderTextOverlay(textOverlay, textOverlayId)}
				</div>
			</Transition>
		);
	}
}